import { FC, PropsWithChildren } from 'react'
import { BoxProps, Flex, FlexboxProps } from '@chakra-ui/react'
import { ScrollableContainer } from './shared-components/ScrollableContainer'

type PageProps = PropsWithChildren &
  Pick<FlexboxProps, 'alignItems'> & {
    containerProps?: BoxProps
  }

const Page: FC<PageProps> = ({ children, alignItems, containerProps }) => {
  return (
    <ScrollableContainer flexGrow="1" flexBasis="0" width="100%" {...containerProps}>
      <Flex
        height="100%"
        flexDirection="column"
        overflow="scroll"
        width="100%"
        alignItems={alignItems}
      >
        {children}
      </Flex>
    </ScrollableContainer>
  )
}

export default Page
